module.exports = __webpack_public_path__ + "img/freesia-alt.ae060eb8.png";